import { FC } from 'react'
import { observer } from 'mobx-react'
import { IJobBase } from '@/types'
import { useStores } from '@/utils'
import { JobSaveAndApplyGroup } from '@/componentsV2/molecules/JobSaveAndApplyGroup'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'

type Props = {
  job: IJobBase
}

export const JobApplyGroupBottom: FC<Props> = observer(({ job }) => {
  const { t } = useTranslation(['jobs-[job_slug]'])
  const { viewer } = useStores()

  return (
    <div className={styles.container}>
      <div className={styles.text}>{t('メンバーと話してみましょう！')}</div>
      {viewer?.isSignedIn && (
        <div className={styles.buttons}>
          <JobSaveAndApplyGroup job={job} />
        </div>
      )}
    </div>
  )
})
